import { ObjectTyped } from '@price-for-profit/micro-services';
import { useSnackbar } from 'notistack';
import { useMutation, useQueryClient } from 'react-query';
import { QUERY_KEYS } from 'shared/constants';
import { useService } from 'shared/providers';
import { UpdateSegmentProps } from 'shared/service';
import { CustomerCommodity } from 'shared/types';

export function useUpdateSegment() {
  const { customerCommodityService } = useService();
  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();

  const mutation = useMutation<CustomerCommodity[], Error, UpdateSegmentProps>(
    request => customerCommodityService.updateSegment(request),
    {
      onSuccess: data => {
        queryClient.setQueryData<CustomerCommodity[]>(QUERY_KEYS.customerCommodities, old => {
          if (old) {
            const updatedRowsMap = ObjectTyped.fromEntries(data.map(c => [c.id, c]));

            return old.map(grid => (updatedRowsMap[grid.id] ? updatedRowsMap[grid.id] : grid));
          }
          return [];
        });
        enqueueSnackbar('Customer segment was updated', { variant: 'success' });
      },
      onError: () => {
        enqueueSnackbar('There was a problem updating segment', { variant: 'error' });
      },
    }
  );

  return mutation;
}
